export default "__VITE_ASSET__6LszNK79__"